import React from 'react';

const SecondSection = ({ featureRef }) => {
  return (
    <div
      ref={featureRef}
      className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-12 p-4 md:p-6 md:mx-10"
    >
      {/* App Design Starts */}
      <div className="featureCards">
        <div>
          <img
            className="w-96 md:w-28 md:mt-4 md:mb-9"
            src="images/appDesign.png"
            alt="App Design"
          />
        </div>
        <div className="ml-4 flex flex-col text-sm md:ml-0">
          <div className="text-lg md:text-xl font-semibold mb-5">
            App Design
          </div>
          <div className="mb-7">
            Uses a trending User Interface to keep you engaged and gives you a
            dutiful experience. The app is swift and user-friendly tailored at
            your convenience.
          </div>
          {/* <div>Read more</div> */}
        </div>
      </div>
      {/* App Design Ends */}
      {/* App Development Starts */}
      <div className="featureCards">
        <div className="order-2 md:order-1">
          <img
            className="w-96 md:w-28 md:p-1 md:mt-2 md:mb-7"
            src="images/appDevelopment.png"
            alt="App Development"
          />
        </div>
        <div className="order-1 md:order-2 mr-10 flex flex-col text-sm md:mr-0">
          <div className="text-lg md:text-xl font-semibold mb-5">
            App Development
          </div>
          <div className="mb-7">
            Beyond the engagement, we wish to keep you safe and happy. There are
            many hidden perks in this app that will reveal themselves as you use
            our app.
          </div>
          {/* <div>Read more</div> */}
        </div>
      </div>
      {/* App Development Ends */}
      {/* App Solution Starts */}
      <div className="featureCards">
        <div>
          <img
            className="w-96 h-32 md:w-40 md:h-auto"
            src="images/appSolution.png"
            alt="App Solution"
          />
        </div>
        <div className="flex flex-col text-sm">
          <div className="text-lg md:text-xl font-semibold mb-5">
            App Solution
          </div>
          <div className="mb-7">
            This app is perfectly safe and secure. It maintains your anonymity,
            so feel free to share your feelings without any hindrance.
          </div>
          {/* <div>Read more</div> */}
        </div>
      </div>
      {/* App Solution Ends */}
    </div>
  );
};

export default SecondSection;
